import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ArrayUtils } from '../utils';

@Pipe({
  name: 'translateArray',
})
export class TranslateArrayPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, ...args: any[]): string {
    const separator = args?.[0] || ', ';
    const maxElement = args?.[1] || 2;

    if (ArrayUtils.isArray(value)) {
      const translatedValue = value.map((v) =>
        this.translateService.instant(v)
      );
      const selectedElement = translatedValue.slice(0, maxElement);

      let textToReturn = selectedElement.join(separator);

      const numberOfRemainingElement = value.length - selectedElement.length;

      if (numberOfRemainingElement > 0) {
        textToReturn += ` (+${
          value.length - numberOfRemainingElement
        } ${this.translateService.instant(
          `pipes.text.other${numberOfRemainingElement > 1 ? 's' : ''}`
        )})`;
      }

      return textToReturn;
    } else {
      return this.translateService.instant(value);
    }
  }
}
